const initialState = {
    defaultConfiguration: null,
    defaultConfigurationDv6: null,
    defaultConfigurationDv7: null,
    loaded: false
  }
  
export default function configs(state = initialState, action) {
    switch (action.type) {
        case 'GET_DEFAULT_CONFIGS_SUCCESS':
            return { ...state,  ...action.payload, loaded: true }  
        default:
            return state
    }
}
